var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#c';
                    var viewUrl = 'sprites.d7297429b712f0db2eb964354e7b2856.svg#view-c';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 131 27',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };